export const environment = {
    production: false,
    apiUrl: 'https://gateway.dev.takenote.cloud/cc',
    productId: 'Change-Group-Demo',
    productType: 'GEN'
};